/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetSimulationCompanySearchCompanyQuery = gql`
  query GetSimulationCompanySearchCompanyQuery($search: String, $department: String) {
    getSimulationCompanySearchCompany_simulation_company(search: $search, department: $department) {
      companies {
 name  
siren  
siret  
addresses {
 fields  
zipCode  
city  
department  
} 
legalForm  
ccnRef  
history {
 name  
siret  
department  
} 
ccnHasAgreement  
}
    }
  }
`;

export default GetSimulationCompanySearchCompanyQuery;
